import { render, staticRenderFns } from "./AfterSalesShippingPage.vue?vue&type=template&id=1d7f2b98&scoped=true"
import script from "./AfterSalesShippingPage.vue?vue&type=script&lang=js"
export * from "./AfterSalesShippingPage.vue?vue&type=script&lang=js"
import style0 from "./AfterSalesShippingPage.vue?vue&type=style&index=0&id=1d7f2b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7f2b98",
  null
  
)

export default component.exports